/**
 * Predicate function for checking if passed parameter is within (min, max) range
 */
export const inRange = (min: number, max: number) => (
  value: number,
): boolean => {
  if (value <= min || value >= max) {
    return false;
  }
  return true;
};
